import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, AsyncStorage,
	Dimensions, Image, FlatList, I18nManager as RNI18nManager, Platform } from "react-native";
	
import i18n from 'i18n-js';

import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import PlaceholderComp from "../utilities/PlaceholderComp";
import { SearchBar } from "react-native-elements";

import HoverableOpacity from "../widgets/HoverableOpacity";
import Main from "../widgets/Main";
import Menu from "../widgets/Menu";
import MainComponent from "../utilities/MainComponent";
import AppContext, {AppProvider} from "../utilities/AppContext"

export default class SearchScreen extends MainComponent {	
	
	static path = ''
	state = {
		store: {},
		selectedIds : [],
		title: "Search",
		topBarData:{title: "Order Look Up", isScrollable: false},
		search: "",
		showMenu 		: false,
		showFullMode 	: true,
		data : [],
		isLoading: false,
		items: [],
		fakeData : new Array(10).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	changeState(states){
		this.setState(states)
	}

	constructor(props) {
		super(props);

		this.changeState = this.changeState.bind(this)
		this.updateSearch = this.updateSearch.bind(this)

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.updateCart()
	}

	updateCart = async () => {

		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})
            console.log("store data found")
            
        } catch (error) {
            console.log(error)
		}
		
		try {
			await Font.loadAsync(color.appFonts);
			var selectedIds = []
			//await AsyncStorage.clear()
			var value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
				value = JSON.parse(value)			
			
			if(value.length > 0){
				var totalPrice = 0
				value.map(item => {
					totalPrice += item.price
					item.addons.map(addon => {
						addon.modifiers.map(modifier => {
							totalPrice += modifier.price
						})
					})
					selectedIds[item.itemId] = item.counter
				})

				this.setState({showCart: true, totalPrice: totalPrice, orderCount: value.length, selectedIds: selectedIds})
			}

		} catch (error) {
			console.log(error)
		}
	}

	updateSearch(searchText){

		console.log(searchText)
		if(searchText == ""){
			this.setState({isLoading: false, search: "", data: []})
			return
		}
		this.setState({isLoading: true, search: searchText, loadingFirebase: true})
		var that = this

		if (this.state.items.length > 0){
			var data = []	

			this.state.items.forEach(item => 
			{	
				let n = item.data.searchText.toLowerCase().search(searchText.toLowerCase());
				if(n > -1)
					data.push(item)								
			})

			that.setState({data: data, isLoading: false})
		}
		else
		{
			firebase.database().ref('data/' + store.storeId + "/").once("value", function(snapshot) {

				//var mMainList = []		
				var data = []

				snapshot.forEach(function(childSnapshot) {								
					
					var childData = childSnapshot.val();
					var itemsList = childData.items
	
					if (itemsList != undefined)
					{
						Object.keys(itemsList).forEach(key => {
							let value = itemsList[key];
							let mItem = {isSelected: false, data: value}
							data.push(mItem)													
						});						
					}
				});

				var mData = []
				data.forEach(item => {	

					if(item.data.searchText == undefined)
						item.data.searchText = ""

					let n = item.data.searchText.toLowerCase().search(searchText.toLowerCase());
					if(n > -1)
						mData.push(item)								
				});

				console.log(mData)
				console.log(data.length)
				that.setState({data: mData, isLoading: false, items: data, searchText: searchText})
	
				//that.setState({data: JSON.parse(JSON.stringify(mMainList)), mainData: mMainList})
	
			}.bind(this), function(error) { 
				console.log(error)
			});
		}
	}

	listRowPressed(item){
		this.context.setItem(item.data)
		this.props.navigation.navigate('details', {
			item: item.data.key
		});		
	}

	/**
	 * 
	 *	IBOutlets 
	 * 
	 */

	/**
	 * 
	 * 
	 */
	openMenu(){
		console.log("Show menu")
		this.setState({showMenu: true});
	}

	// List View 
	renderDetails(){
		return (
			<View style={styles.container}>
				
				<View style={{height: 70, flexDirection: "row", justifyContent: "center", alignContent:"center", alignItems:"center"}}>

					<SearchBar		
						inputStyle={{textAlign: "left", outline: "none", 											
						borderWidth:0, fontSize: 14, fontFamily: "main-regular"}}
						searchIcon={false}			
						inputContainerStyle={{backgroundColor: '#F5F5F5', borderRadius: 10}}
						containerStyle={{	
							backgroundColor: 'rgba(0,0,0,0)', borderBottomColor: 'transparent', flex: 1,
							borderTopColor: 'transparent', marginLeft: 15, marginRight: 15,
						}}
						lightTheme={true}
						placeholder={i18n.t("searchItems")}
						onChangeText={this.updateSearch}
						value={this.state.search}
					/>

					<TouchableOpacity style={{justifyContent:"center", alignContent:"center", alignItems:"center", marginLeft: "auto", marginRight: 15}}
							onPress={() => this.props.navigation.navigate('menu')}
					>
						<View style={{justifyContent:"center", alignContent:"center", alignItems:"center", marginLeft: "auto"}}>
							<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 16 }}>{i18n.t("cancel")}</Text>
						</View>

					</TouchableOpacity>

				</View>

				<View style={{height: 1, backgroundColor: color.bigSeparator}}/>

				{this.state.data.length == 0 && !this.state.isLoading && (
					<View  style={{flex:1, marginTop: 15, marginLeft: 15}}>
						<Text style={{textAlign:"left", fontFamily: 'main-regular', color: "black"  , fontSize: 22 }}>{i18n.t("findProducts")}</Text>
						<Text style={{textAlign:"left", fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14, marginTop: 10 }}>{i18n.t("typein")}</Text>
					</View>					
				)}

				{!this.state.isLoading && (
					<FlatList
						showsHorizontalScrollIndicator={false}
						data={this.state.data}
						renderItem={this.renderListItem}
						keyExtractor={item => item.title}
					/>
				)}
				{this.state.isLoading && (
					this.state.fakeData.map((e, i) => <PlaceholderComp 
					style={{position: "absolute"}}
					key={i} />)
				)}

			</View>
		)
	}

	renderListItem = ({ item, index }) => 
	{	
		var height = 145
		if (item.isLast)
			height = height + 8

		var seprationColor = color.bigSeparator
		var counter = this.state.selectedIds[item.data.key] 
		if(counter != undefined)
			seprationColor = this.state.store.primaryColor	
		else
			counter = 0

		var textWidth = this.state.width - 15 - 15 - 90
		if(this.state.showFullMode)
			textWidth = this.state.width * .33 - 15 - 15 - 90
		
		var name 	= item.data.name
        var details = item.data.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.data.nameSec
            details = item.data.detailsSec
        }

        if(name == undefined || name == "")
            name = item.data.name
        if(details == undefined || details == "")
			details = item.data.details
		
		var price = +item.data.price
		price = price.toFixed(3)
		var priceText = price
		if(price == 0)
			priceText = i18n.t("priceSelection")
		else
		{
			if(RNI18nManager.isRTL)
				priceText = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				priceText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
		}

		return (
				<HoverableOpacity style={{height: height}}
					onPress={() => this.listRowPressed(item)}
				>
					<View  style={{height: height}}>
						
						<View style={{height: 1, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
						
						<View  style={{ flexDirection: "row", height: height - 9, justifyContent: "center", alignContent: "center", alignItems:"center"}}>
							   
								{ counter > 0 && (
								<View style={{width: 4, height: height - 1, backgroundColor: seprationColor, justifyContent: "center"}}/>
								)}
								<View style={{marginLeft: 15, height: '100%'}}>
									
									<View style={{flexDirection: "row", marginTop: 15}}>
										{ counter > 0 && (
											<Text style={{textAlign:"left", fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 16 }}>{counter}x </Text>
										)}
										<Text style={{textAlign:"left", fontFamily: 'main-regular', color: "black", fontSize: 16 }}>{name}</Text>
									</View>

									<Text style={{textAlign:"left", marginTop: 5, width: textWidth, fontFamily: 'main-regular', fontSize: 12}}>{details}</Text>
									
									<View style={{marginTop: "auto", width: 110, height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, marginBottom: 15, justifyContent: "center", alignItems: "center", alignContent: "center"}}>
										<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 11, fontWeight:"bold", textAlign: "center"}}>{priceText}</Text>
									</View>

								</View>
								{ item.data.images != undefined && item.data.images.length > 0 && (
									<Image source={item.data.images[0]} style={{width: 90, height: 90, borderRadius: 5, overflow:"hidden", marginLeft: "auto", marginRight: 15}}/>
								)}
						</View>

						{ item.isLast &&( <View style={{height: 8, backgroundColor: color.bigSeparator}}/> )} 

					</View>
				</HoverableOpacity>
		);
	}
		
	render() {
		var that = this
		return (

			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{height: this.state.height, width: this.state.width * .33}}>
								{this.renderDetails()}
							</View>	

							<Main {...this.state} changeMenu={this.changeMenu} />

						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && (
						<View style={styles.container}>						
													
							<View style={{height: this.state.height}}>
								{that.renderDetails()}
							</View>	

						</View>
					)}

					{!this.state.showFullMode && this.state.showMenu && (					
						<View style={styles.container}>						

							<Menu {...this.state} changeState={this.changeState} />
							
						</View>
					)}	
					
				</View>
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	}
});